import { Ticker } from '../stories/kiplinger_tools/ticker/Ticker';

export default function TickerTool() {
  // console.log("router code: ", tickerSymbol);
  return (
    <main>
      <Ticker />
    </main>
  );
}
